import styled from 'styled-components/macro';
import * as colors from '../../common/colorConstants';
import * as breakpoints from '../../common/mediaQueries';

export const Container = styled.div`
  background-color: ${colors.white};
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: flex;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
  }
`;

export const ContentBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 223px auto auto;
  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin: 180px auto auto;
  }
  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
    margin: 52px auto auto;
  }
  @media screen and (max-width: ${breakpoints.maxMobile}) {
    margin: 52px 0 0 0;
  }
`;

export const ErrorMessage = styled.div`
  color: ${colors.red};
  margin-bottom: 20px;
`;
